/**
 * DIISEA Product Comparison — expand / collapse rows
 * Scoped per [data-diisea-comparison], Theme Editor safe.
 */
(function () {
  var instances = new WeakMap();

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }

  function DiiseaComparison(root) {
    this.root = root;
    this.toggle = root.querySelector('[data-dpc-toggle]');
    this.bound = {};
    this.applyVisibility();
    this.bind();
  }

  DiiseaComparison.prototype.visibleLimit = function () {
    if (this.root.getAttribute('data-show-all') === 'true') return Infinity;
    var mobile = parseInt(this.root.getAttribute('data-initial-mobile'), 10);
    var desktop = parseInt(this.root.getAttribute('data-initial-desktop'), 10);
    if (isMobile()) return isNaN(mobile) ? 4 : mobile;
    return isNaN(desktop) ? 8 : desktop;
  };

  DiiseaComparison.prototype.applyVisibility = function () {
    var limit = this.visibleLimit();
    var expanded = this.root.classList.contains('is-expanded');
    var rows = this.root.querySelectorAll('[data-dpc-item]');
    var showToggle = this.root.getAttribute('data-show-toggle') !== 'false';
    var needsToggle = rows.length > limit && limit !== Infinity && showToggle;

    rows.forEach(function (row) {
      var index = parseInt(row.getAttribute('data-dpc-index'), 10);
      if (isNaN(index)) index = 0;
      var hide = !expanded && needsToggle && index >= limit;
      row.hidden = hide;
      row.classList.toggle('is-collapsed-row', hide);
    });

    // Hide category headers when all items in category are hidden
    this.root.querySelectorAll('[data-dpc-category]').forEach(function (cat) {
      var key = cat.getAttribute('data-dpc-category');
      var items = this.root.querySelectorAll('[data-dpc-item][data-dpc-cat="' + key + '"]');
      var anyVisible = false;
      items.forEach(function (item) {
        if (!item.hidden) anyVisible = true;
      });
      cat.hidden = !anyVisible;
    }.bind(this));

    if (this.toggle) {
      this.toggle.hidden = !needsToggle;
      this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var expandLabel = this.root.getAttribute('data-expand-label') || 'View Full Comparison';
      var collapseLabel = this.root.getAttribute('data-collapse-label') || 'Show Less';
      var labelEl = this.toggle.querySelector('[data-dpc-toggle-label]');
      if (labelEl) labelEl.textContent = expanded ? collapseLabel : expandLabel;
    }
  };

  DiiseaComparison.prototype.bind = function () {
    var self = this;
    if (this.toggle) {
      this.bound.onToggle = function () {
        self.root.classList.toggle('is-expanded');
        self.applyVisibility();
        if (!prefersReducedMotion() && self.root.classList.contains('is-expanded') === false) {
          try {
            self.root.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          } catch (e) {}
        }
      };
      this.toggle.addEventListener('click', this.bound.onToggle);
    }

    this.bound.onResize = function () {
      if (self._resizeTimer) window.clearTimeout(self._resizeTimer);
      self._resizeTimer = window.setTimeout(function () {
        self.applyVisibility();
      }, 120);
    };
    window.addEventListener('resize', this.bound.onResize, { passive: true });
  };

  DiiseaComparison.prototype.destroy = function () {
    if (this.toggle && this.bound.onToggle) {
      this.toggle.removeEventListener('click', this.bound.onToggle);
    }
    if (this.bound.onResize) {
      window.removeEventListener('resize', this.bound.onResize);
    }
    if (this._resizeTimer) window.clearTimeout(this._resizeTimer);
    instances.delete(this.root);
  };

  function initRoot(root) {
    if (!root || instances.has(root)) return;
    instances.set(root, new DiiseaComparison(root));
  }

  function initAll() {
    document.querySelectorAll('[data-diisea-comparison]').forEach(initRoot);
  }

  function destroyIn(node) {
    if (!node) return;
    var root =
      node.matches && node.matches('[data-diisea-comparison]')
        ? node
        : node.querySelector && node.querySelector('[data-diisea-comparison]');
    if (root && instances.has(root)) instances.get(root).destroy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    destroyIn(event.target);
    if (event.target) {
      var root = event.target.querySelector('[data-diisea-comparison]');
      if (root) initRoot(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyIn(event.target);
  });
})();
